/* eslint-disable @next/next/no-img-element -- logo pieces are positioned exactly as in Figma */

import React from "react";
import { cn } from "@/lib/utils";
import { PageTrademania2Schema } from "@/sanity/pages/PageTrademania2Template";

import line from "@/public/trademania-2/footer-line.svg";

// Figma "Frame" 140 × 33.939: [top, right, bottom, left] insets in %
const LOGO: [number, number, number, number][] = [
  [0, 76.32, 0, 0],
  [1.25, 76.62, 1.25, 0.3],
  [20.67, 82.74, 56.48, 6.4],
  [42.24, 81, 18.92, 4.65],
  [33.92, 65.23, 33.93, 28.56],
  [33.92, 57.84, 33.93, 35.64],
  [33.92, 50.09, 33.93, 42.49],
  [33.92, 42.73, 33.93, 50.57],
  [33.92, 35.82, 33.93, 58.43],
  [33.92, 26.53, 33.93, 65.31],
  [33.92, 18.46, 33.93, 74.12],
  [33.92, 11.4, 33.93, 82.2],
  [33.92, 8.27, 33.93, 90.06],
  [33.92, 0.2, 33.93, 92.38],
];

/** Pieces scale with the frame, so `className` can resize it (keep the 140 × 33.939 ratio). */
export function Logo({ className }: { className?: string }) {
  return (
    <div className={cn("relative h-[4.242rem] w-[17.5rem] shrink-0 overflow-clip", className)} role="img" aria-label="TradeMania">
      {LOGO.map(([t, r, b, l], i) => (
        <div
          key={i}
          className={i === 1 ? "absolute mix-blend-soft-light" : "absolute"}
          style={{ top: `${t}%`, right: `${r}%`, bottom: `${b}%`, left: `${l}%` }}
        >
          {i === 1 ? (
            <img src={`/trademania-2/footer-logo-${i}.svg`} alt="" className="absolute left-[-2.19%] top-[-2.14%] block h-[104.28%] w-[104.38%] max-w-none" />
          ) : (
            <img src={`/trademania-2/footer-logo-${i}.svg`} alt="" className="absolute inset-0 block h-full w-full max-w-none" />
          )}
        </div>
      ))}
    </div>
  );
}

export default function Footer({ data }: { data: PageTrademania2Schema }) {
  return (
    <footer className="m-[4px] rounded-[8px] border border-black/10 bg-white px-[2.625rem] pb-[3.125rem] pt-[3.125rem] lg:m-[6px] lg:px-0 lg:pb-[3.5rem] lg:pt-[3.625rem]">
      <div className="mx-auto flex w-full max-w-[160rem] flex-col gap-[2rem] pb-[2px] lg:gap-[2.125rem] lg:px-[3rem]">
        <div className="flex w-full flex-col items-start justify-between gap-[2rem] sm:flex-row sm:items-center">
          <Logo />
          {data?.footerCopyright && (
            <p className="font-geist text-[1.75rem] font-medium leading-[1.75rem] text-[#1F231A]/[.72]">
              {data.footerCopyright}
            </p>
          )}
        </div>
        <img src={line.src} alt="" aria-hidden className="h-px w-full" />
        {data?.footerDisclaimer && (
          <p className="max-w-[146.125rem] font-geist text-[1.75rem] leading-[2.625rem] text-[#1F231A]/[.72]">
            {data.footerDisclaimer}
          </p>
        )}
      </div>
    </footer>
  );
}
